let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2lr6E")).then(() => parcelRequire('dKoa0'));